import { gql } from '@apollo/client';

export const DROPBOX_VIDEO_METADATA = gql`
  query DropboxVideoMetadata($url: String!) {
    dropboxVideoMetadata(url: $url) {
      title
      duration
      width
      height
      source_size_bytes
    }
  }
`;
